<template>
  <div>
    <a-modal
      :title="getTitle"
      :width="540"
      :visible="visible"
      @cancel="handleCancel"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel"> 取消 </a-button>
        <a-button
          key="submit"
          type="primary"
          @click="onSubmit"
          :loading="confirmLoading"
        >
          保存
        </a-button>
      </template>
      <a-spin :spinning="loading">
        <div>
          <div class="flex mt10">
            <a-input
              class="woyaou-input"
              style="width: 460"
              prefix="店铺名"
              placeholder="请输入门店名称"
              v-model="form.shop_name"
              :maxLength="20"
            >
            </a-input>
            <!-- <a-input
              class="woyaou-input ml20"
              prefix="手机号"
              style="width: 230px"
              placeholder="请输入手机号"
              v-model="form.mobile"
              :maxLength="20"
            >
            </a-input> -->
          </div>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    aid: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      confirmLoading: false,
      form: {
        shop_name: "",
      },
    };
  },
  computed: {
    getTitle() {
      if (this.aid == 0) {
        return "创建商铺";
      } else {
        return "编辑商铺";
      }
    },
  },
  created() {
    // this.loaddata();
  },
  methods: {
    // loaddata() {
    //   if (this.loading == true) return;
    //   this.loading = true;
    //   this.$http
    //     .papi("platform/terminal/showShopAccount", {
    //       aid: this.aid,
    //     })
    //     .then((res) => {
    //       if (res.detail) {
    //         this.form = res.detail;
    //       }
    //       this.loading = false;
    //     })
    //     .catch((res) => {
    //       console.log(res);
    //       this.loading = false;
    //     });
    // },

    /**
     * 取消弹窗
     */
    handleCancel() {
      	this.$emit("cancel");
    },

    /**
     * 提交数据
     */
    onSubmit() {
		if (this.confirmLoading == true) return;
		this.confirmLoading = true;

		this.$http
			.papi("platform/account/createShop", {
				app_id: 1,
				name: this.form.shop_name,
				processEnv: 'production',
				auth_token: localStorage.getItem('account-token')
			})
			.then((res) => {
				this.$message.success("操作成功", 1, () => {
					this.confirmLoading = false;
					this.$emit("ok");

					/*
					{
						"code": 200,
						"msg": "操作成功",
						"time": 1764163868,
						"data": {
							"shop_token": "3c9xn",
							"base_url": "http:\/\/local.wuyangadmin.com\/beautiful#\/"
						}
					}
					*/
				});
			})
			.catch((res) => {
				console.log(res);
				this.confirmLoading = false;
			});
    },
  },
};
</script>

<style></style>
